import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (overrideClasses?: any) =>
  createStyles({
    content: {
      marginBottom: 30,
      flexWrap: 'wrap',
      justifyContent: 'space-evenly',
    },
    pin: {
      marginLeft: 6,
    },
    cardContainer: {
      padding: '9px 5px !important',
      minWidth: 160,
      '& .MuiGrid-root': { width: '100%' },
    },
    hasType: {
      color: palette.gray,
    },
    buttonFooter: {
      background: palette.deepBlue,
      width: 80,
      height: 80,
      marginRight: 80,
      marginTop: 56,
    },
    buttonFooterSky: {
      background: palette.pink,
      width: 80,
      height: 80,
      marginRight: 80,
      marginTop: 56,
    },
    footerName: {
      width: 80,
      marginTop: 30,
      fontSize: 12,
    },
    footerContent: {
      display: 'flex',
    },
    disabled: {
      background: palette.lightGray,
      pointerEvents: 'none',
    },
    partnerSelector: {
      fontSize: 14,
      color: palette.navCompanyContextActions,
      fontWeight: 550,
      padding: '1px 10px',
    },
    buttonSelectPartner: {
      padding: 1,
      color: palette.navCompanyContextActions,
      borderColor: palette.navCompanyContextActions,
      marginLeft: 5,
    },
    ...overrideClasses,
  });

export const overrideCard = {
  alignItems: 'flex-start',
  display: 'flex',
  minHeight: 80,
  minWidth: 160,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 160,
    height: 168,
    borderRadius: '50%',
    zIndex: 1,
    top: -74,
    right: -119,
    opacity: 0.5,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 159,
    height: 189,
    borderRadius: '50%',
    top: -135,
    right: -89,
    opacity: 0.5,
  },
};
